import React from "react";
import CommonRow from "../common-row";
const SixteenStories3AdWithTagSearchAndLoadMore = props => {
  return <CommonRow {...props} />;
};

export default SixteenStories3AdWithTagSearchAndLoadMore;
